import type { SVGProps } from "react";
export interface ShoesRunIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ShoesRunIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ShoesRunIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m16 19.875.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H2a1.125 1.125 0 1 1 0-2.25zm-9-3 .115.006a1.125 1.125 0 0 1 0 2.238L7 19.125H4a1.125 1.125 0 0 1 0-2.25zm-3-3 .115.006a1.125 1.125 0 0 1 0 2.238L4 16.125H2a1.125 1.125 0 1 1 0-2.25zm12.07-3.52a1.125 1.125 0 0 1 .805 2.098l-2.418 1.075a1.125 1.125 0 0 1-.914-2.055l2.42-1.075zm-1.496-3.001a1.125 1.125 0 0 1 .806 2.097l-2.423 1.077a1.125 1.125 0 0 1-.914-2.055l2.424-1.078z"
      />
      <path
        fill={color}
        d="M20.875 18.115c0-.789-.493-1.493-1.233-1.762l-1.625-.562a2.13 2.13 0 0 1-1.207-1.06l-3.804-7.635c-.348.121-.716.2-1.081.224-.847.057-1.826-.148-2.615-.843l-.155-.145c-.707-.707-.961-1.629-1.055-2.309l-2.99 2.99a1.876 1.876 0 0 0 .01 2.661l10.342 10.201h3.652a1.76 1.76 0 0 0 1.761-1.76m2.25 0a4.01 4.01 0 0 1-4.01 4.01H15.41a2.12 2.12 0 0 1-1.336-.473l-.156-.139L3.54 11.275a4.124 4.124 0 0 1-.02-5.853l4.22-4.217.086-.078a1.125 1.125 0 0 1 1.505.078l.662.66c.248.248.366.599.319.947l-.004.036a4 4 0 0 0 .007.754c.052.496.197.905.43 1.139l.099.086c.24.188.562.274.931.25.45-.03.791-.214.914-.336l.101-.09a1.125 1.125 0 0 1 1.703.383l4.306 8.647 1.578.545.01.004.302.12a4.13 4.13 0 0 1 2.436 3.765"
      />
    </svg>
  );
}
